import {createTheme} from '@mui/material/styles';

const mainColor = '#b2b2b2';
const lightColor = '#d0d0d0';
const darkColor = '#8a8a8a';

export const headerTheme = createTheme({
  palette: {
    primary: {
      light: lightColor,
      main: mainColor,
      dark: darkColor,
      contrastText: '#fff',
    },
    text: {
      disabled: darkColor,
      primary: mainColor,
      secondary: lightColor
    },
  },
  typography: {
    allVariants: {
      color: mainColor
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-outlined': {
            borderColor: mainColor,
            color: darkColor
          }
        }
      }
    }
  }
});